import axios from '../api/axiosInstance';

export const fetchDeliveryCharges = (params) => {
  return axios.get('/delivery-charges', { params });
};

export const createDeliveryCharge = (data) => {
  return axios.post('/delivery-charges', data);
};

export const updateDeliveryCharge = (id, data) => {
  return axios.put(`/delivery-charges/${id}`, data);
};

export const updateDeliveryChargeStatus = (id, isActive) => {
  return axios.patch(`/delivery-charges/${id}/status`, { isActive });
};

export const deleteDeliveryCharge = (id) => {
  return axios.delete(`/delivery-charges/${id}`);
};

